import { CustomFieldType } from './custom-field-type.enum';
import { ItemType } from '../domain/common/misc/item-type.enum';
var SimpleCustomFieldBuilder = /** @class */ (function () {
    function SimpleCustomFieldBuilder() {
        this.customField = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            name: 'bob-bob-bob',
            displayName: 'Bob',
            data: {
                data: {
                    title: 'A Title',
                    translatedTitles: {},
                    placeHolder: 'A Placeholder',
                    description: 'A Description',
                    values: [],
                    disabled: false
                },
                deletedValues: []
            },
            creationDate: Date.now(),
            lastUpdateDate: Date.now(),
            type: CustomFieldType.TEXT,
            itemType: ItemType.USER,
        };
    }
    SimpleCustomFieldBuilder.prototype.withId = function (id) {
        this.customField.id = id;
        return this;
    };
    SimpleCustomFieldBuilder.prototype.withName = function (name) {
        this.customField.name = name;
        return this;
    };
    SimpleCustomFieldBuilder.prototype.withDisplayName = function (displayName) {
        this.customField.displayName = displayName;
        return this;
    };
    SimpleCustomFieldBuilder.prototype.withData = function (data) {
        this.customField.data = data;
        return this;
    };
    SimpleCustomFieldBuilder.prototype.withDataValues = function (values) {
        this.customField.data.data.values = values;
        return this;
    };
    SimpleCustomFieldBuilder.prototype.withCreationDate = function (creationDate) {
        this.customField.creationDate = creationDate;
        return this;
    };
    SimpleCustomFieldBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.customField.lastUpdateDate = lastUpdateDate;
        return this;
    };
    SimpleCustomFieldBuilder.prototype.withType = function (type) {
        this.customField.type = type;
        return this;
    };
    SimpleCustomFieldBuilder.prototype.withItemType = function (itemType) {
        this.customField.itemType = itemType;
        return this;
    };
    SimpleCustomFieldBuilder.prototype.build = function () {
        return this.customField;
    };
    return SimpleCustomFieldBuilder;
}());
export { SimpleCustomFieldBuilder };
//# sourceMappingURL=simple-custom-field.builder.js.map